<template>
  <div>
    <card-toolbar icon="import_export" :title="$tc('backup')" />
    <v-tabs
      show-arrows
      :ripple="false"
      v-model="selectedTab"
      slider-color="dinamo"
      background-color="transparent"
      centered
      class="mb-2"
    >
      <v-tab v-for="tab in tabs" :id="`tab_${tab.id}`" :key="`tab-${tab.id}`">
        {{ tab.title }}
      </v-tab>
    </v-tabs>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-tabs-items v-model="selectedTab">
        <v-tab-item class="mt-4">
          <hsm-backup-form />
        </v-tab-item>
        <v-tab-item class="mt-4">
          <hsm-restore-form />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
import HsmBackupForm from './form/HsmBackupForm'
import HsmRestoreForm from './form/HsmRestoreForm'

export default {
  components: {
    HsmBackupForm,
    HsmRestoreForm,
    CardToolbar
  },
  data () {
    return {
      selectedTab: 0
    }
  },
  computed: {
    tabs () {
      return [
        {
          title: this.$tc('backup'),
          id: 'backup'
        },
        {
          title: this.$tc('restore'),
          id: 'restore'
        }
      ]
    }
  }
}
</script>
